const TEXT_FIELD_DATA_ATTRIBUTE = 'data-checkbox-group-validator';
const CHECKBOX_DATA_ATTRIBUTE = 'data-checkbox-group';
const ID_SEPARATOR = ' ';

const getCheckboxesInGroup = (groupId) =>
  Array.from(
    document.querySelectorAll(`input[${CHECKBOX_DATA_ATTRIBUTE}="${groupId}"]`)
  );

const getValidatedTextFields = () =>
  Array.from(document.querySelectorAll(`input[${TEXT_FIELD_DATA_ATTRIBUTE}]`));

const triggerValidation = (textField) => {
  const event = new Event('input', {
    bubbles: true,
    cancelable: false
  });

  textField.dispatchEvent(event);
};

const toggleIdInTextField = (textField, id) => {
  let checkedIds = textField.value.split(ID_SEPARATOR);

  if (checkedIds.includes(id)) {
    checkedIds = checkedIds.filter((checkedId) => checkedId !== id);
  } else {
    checkedIds.push(id);
  }

  textField.value = checkedIds.join(ID_SEPARATOR);
  triggerValidation(textField);
};

const setupChangeListener = (checkbox, textField) => {
  checkbox.addEventListener('change', () => {
    toggleIdInTextField(textField, checkbox.id);
  });
};

const initializeCheckboxGroupValidation = () => {
  // Grab all of the special hidden text fields in the form of an array
  // we use these to validate checkbox groups that require at least one selection
  const textFields = getValidatedTextFields();

  textFields.forEach((textField) => {
    const groupId = textField.dataset.checkboxGroupValidator;
    const checkboxes = getCheckboxesInGroup(groupId);

    checkboxes.forEach((checkbox) => {
      setupChangeListener(checkbox, textField);
    });
  });
};

export { initializeCheckboxGroupValidation };
